/* eslint-disable no-undef */


const loadGoogleCharts = () => {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://www.gstatic.com/charts/loader.js';
        script.onload = () => {
            google.charts.load('current', { packages: ['corechart'] });
            google.charts.setOnLoadCallback(resolve);
        };
        script.onerror = reject;
        document.head.appendChild(script);
    });
};

export default loadGoogleCharts;
